var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-button',{directives:[{name:"indexed",rawName:"v-indexed"}],attrs:{"type":"primary","icon":_vm.icon,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":()=>_vm.$emit('new')}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }